import { render } from "./ZamgRectangle.vue?vue&type=template&id=03531e29&ts=true"
import script from "./ZamgRectangle.vue?vue&type=script&lang=ts"
export * from "./ZamgRectangle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__